import { useEffect, useRef, useState } from "react";

// for handling click outside div
export const useComponentVisible = (initialIsVisible: any) => {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
  const componentVisibleRef = useRef(null);

  const handleClickOutside = (event: any) => {
    // @ts-ignore
    if (componentVisibleRef.current && !componentVisibleRef.current.contains(event.target)) {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return { componentVisibleRef, isComponentVisible, setIsComponentVisible };
};
